<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Welcome!</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="content">
    <p>
      Congratulations, you've logged in successfully <br/>
      Tap <a (click)="goTo('complete-registration')" class="tw-text-blue-600"> here </a>
      to complete the Registration!"
    </p>
  </div>
</ion-content>
